<template>
<div class="menu z100">
  <div v-bind:class="{einverstanden:einverstanden}" id="cookienachricht"><span class="cookietext">Wir verwenden Google Analytics um unser Angebot für Sie zu optimieren. Mehr Informationen in unserer Datenschutzerklärung.</span> <span class="pointer deaktivieren" @click="setDeaktiviert">Google Analytics deaktivieren</span> - <span @click="setEinverstanden"><img src="/static/assets/alle/einverstanden2.png" /></span></div>
  <div class="inner">
    <div class="burgermenu pointer">
      <img class="burgerbutton" src="/static/assets/alle/Menue.png"  @click="setmenuvisible"/>
    </div>
    <!-- transition name="move" -->
      <div class="hormenu"  v-bind:class="{active:getmenuvisible, inactive:!getmenuvisible}">
        <!-- <img src="/static/assets/alle/Wolkenmenue.png" usemap="#menue-map">
        <map name="menue-map">
        <router-link to="/spiele" tag="area" target="" alt="wuerfel" title="wuerfel" href="frontpage.html" coords="23,82,8,82,2,67,5,57,7,39,11,29,24,31,31,18,45,18,55,18,59,9,74,11,84,11,96,13,103,16,114,17,121,23,129,28,139,42,132,54,125,62,122,71,113,79,104,77,97,83,90,89,71,90,57,83,52,88,41,93,33,88" shape="poly" />
        <router-link to="/leseraum" tag="area" title="buch" href="#page2" coords="179,76,167,75,162,63,167,49,168,32,178,29,192,16,204,18,216,8,228,10,244,10,253,14,263,15,273,17,279,25,292,33,295,50,287,56,281,67,276,75,266,78,259,76,253,83,242,88,229,84,220,86,215,80,211,87,197,91,188,83" shape="poly" />
        <router-link to="/veranstaltungen" tag="area"  target="" alt="kalender" title="kalender" href="#page3" coords="337,68,323,61,321,42,331,34,333,20,342,14,351,15,360,8,371,9,378,11,390,6,398,7,401,12,412,11,421,16,422,21,437,24,446,32,450,41,459,56,453,65,444,72,435,82,426,86,410,80,405,87,396,89,384,81,379,85,370,80,365,76,356,83,347,82,341,76" shape="poly" />
        <router-link to="/gewinn" tag="area" target="" alt="geschenk" title="geschenk" href="gewinn.html" coords="499,72,485,66,481,50,487,39,489,23,503,16,513,13,520,6,529,9,538,8,547,4,558,8,565,5,572,6,579,13,585,14,600,17,601,25,609,31,617,41,617,52,605,61,599,70,594,76,582,79,575,74,569,81,557,85,548,77,543,81,535,82,531,76,524,82,514,83,506,80" shape="poly" />
        </map> -->
        <div class="menu_open" v-bind:class="{active:getMenuactive, inactive:!getMenuactive}">
        <router-link to="/spiele" tag="div" class="menu_01"><img src="/static/assets/alle/Icon_Spiel.png" usemap="#menue-map"></router-link>
        <router-link to="/leseraum" tag="div" class="menu_02"><img src="/static/assets/alle/Icon_Vorlesen.png" usemap="#menue-map"></router-link>
        <router-link to="/gewinn" tag="div" class="menu_03"><img src="/static/assets/alle/Icon_Geschenk.png" usemap="#menue-map"></router-link>
        <router-link to="/veranstaltungen" tag="div" class="menu_04"><img src="/static/assets/alle/Icon_Event.png" usemap="#menue-map"></router-link>
        </div> 
      </div>
    <!-- /transition -->
  </div>
</div>
</template>
<script>
/* eslint no-trailing-spaces: "off" */
window.$ = window.jQuery = require('jquery')
export default {
  name: 'Topmenu',
  data () {
    var einverstanden = window.localStorage.getItem('einverstanden')
    if (einverstanden !== 'true') { 
      einverstanden = false
    } else {
      einverstanden = true
    }
    return {
      who: 'Topmenu',
      retval: 0,
      menuvisible: false,
      menuactive: false,
      einverstanden: einverstanden
    }
  },
  computed: {
    getMenuactive () {
      return this.menuactive
    },
    getmenuvisible () {
      return this.menuvisible
    },
    getEinverstanden () {
      if (window.einverstanden === true) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    einverstanden: function (oldval, newval) {
      console.log('einverstanden: ', newval)
    }
  },
  methods: {
    setDeaktiviert () {
      window.localStorage.setItem('optout', true)
      window.optout = true
      window.einverstanden = true
      console.log('google analytics deaktiviert!')
    },
    setEinverstanden () {
      window.einverstanden = true
      this.einverstanden = true   
      window.localStorage.setItem('einverstanden', this.einverstanden)
      console.log('einverstanden', this.einverstanden)   
    },
    setMenuActive () {
      this.menuactive = true
    },
    setMenuInactive () {
      // this.menuactive = false // animation Nach klick starten
      this.menuvisible = false
    },
    setmenuvisible () {
      console.log('getmenuvisible')
      if (!this.menuactive) { // animation später starten
        // window.currentAudio = new Audio('/static/assets/sounds/01_Frontpage/SFX/MenueWolke_ohne_Klick_V1.mp3')
        // window.currentAudio.muted = window.muted
        // window.currentAudio.play()
        
        this.menuvisible = true
        setTimeout(this.setMenuActive, 100)
      } else {
        this.menuactive = false 
        setTimeout(this.setMenuInactive, 500)
      }
    }
  },
  mounted () {
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
      window.hintergrundSound.pause()
    } catch (e) {}
  }  
}
</script>
<style scoped>
.einverstanden { display: none; }
/* Z-Index - Level */
.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}
.z100 { z-index:9999; }
.menu { position: absolute; top: 6%; right: 15%; height: auto; }
.menu .inner { position: relative; }
.menu .inner .burgermenu { position: absolute;top:0px; right:0px; }
.menu .inner .hormenu { position: absolute;top:0px; right:150px; }
.menu.active .inner .hormenu { display: block; }
area {outline:0;}

/* VHo Menü */

.menu_open.active{
    width: 650px;
    overflow:hidden;
}
.menu_open div {
    position: absolute;
    cursor:pointer;
}
/* .menu_01 {
    opacity:0;
    left: 0px;
}
.menu_02 {
    opacity:0;
    left: 160px;
}
.menu_03 {
    opacity:0;
    left: 320px;
}
.menu_04 {
    opacity:0;
    left: 480px;
} */
.menu_01 {
    opacity:0;
    left: 650px;
}
.menu_02 {
    opacity:0;
    left: 650px;
}
.menu_03 {
    opacity:0;
    left: 650px;
}
.menu_04 {
    opacity:0;
    left: 650px;
    display: none;
}

/* move move_menu01 */
.menu_open.active .menu_01 {
  animation: move_menu01 .5s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}
.move_menu01-leave-active {
  animation: move_menu01 .5s reverse;
}
@keyframes move_menu01 {
  0% { left: 650px; opacity:0; }
  100% { left: 160px; opacity:1; }
}
/* move move_menu02 */
.menu_open.active .menu_02 {
  animation: move_menu02 .5s;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
}
.move_menu02-leave-active {
  animation: move_menu02 .5s reverse;
}
@keyframes move_menu02 {
  0% { left: 650px; opacity:0; }
  100% { left: 320px; opacity:1; }
}
/* move move_menu03 */
.menu_open.active .menu_03 {
  animation: move_menu03 .5s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
}
.move_menu03-leave-active {
  animation: move_menu03 .5s reverse;
}
@keyframes move_menu03 {
  0% { left: 650px; opacity:0; }
  100% { left: 480px; opacity:1; }
}
/* move move_menu04 */
.menu_open.active .menu_04 {
  animation: move_menu04 .5s;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
}
.move_menu04-leave-active {
  animation: move_menu04 .5s reverse;
}
@keyframes move_menu04 {
  0% { left: 650px; opacity:0;}
  100% { left: -480px; opacity:0; }
}

.hormenu.inactive{display:none;}
.hormenu.active{display:block;}

/* move move_menu01
  
  NEUER
  
  /* move move_menu01 
.menu_open.active .menu_01 {
  animation: move_menu01 .5s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}
.move_menu01-leave-active {
  animation: move_menu01 .5s reverse;
}
@keyframes move_menu01 {
  0% { left: 650px; opacity:0; }
  100% { left: 0px; opacity:1; }
}
/* move move_menu02 
.menu_open.active .menu_02 {
  animation: move_menu02 .5s;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
}
.move_menu02-leave-active {
  animation: move_menu02 .5s reverse;
}
@keyframes move_menu02 {
  0% { left: 650px; opacity:0; }
  100% { left: 160px; opacity:1; }
}
/* move move_menu03 
.menu_open.active .menu_03 {
  animation: move_menu03 .5s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
}
.move_menu03-leave-active {
  animation: move_menu03 .5s reverse;
}
@keyframes move_menu03 {
  0% { left: 650px; opacity:0; }
  100% { left: 320px; opacity:1; }
}
/* move move_menu04 
.menu_open.active .menu_04 {
  animation: move_menu04 .5s;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
}
.move_menu04-leave-active {
  animation: move_menu04 .5s reverse;
}
@keyframes move_menu04 {
  0% { left: 650px; opacity:0;}
  100% { left: 480px; opacity:1; }
}

.hormenu.inactive{display:none;}
.hormenu.active{display:block;}
  
  ÄLTER
  
  
.menu_open.inactive .menu_01 {
  animation: move_menu01-zu .5s;
  animation-delay: 0s;
  animation-direction: reverse;
}
.move_menu01-leave-active {
  animation: move_menu01 .5s reverse;
}
@keyframes move_menu01-zu {
  0% { left: 650px; opacity:0; }
  100% { left: 0px; opacity:1; }
}
move move_menu02
.menu_open.inactive .menu_02 {
  animation: move_menu02-zu .5s;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
}
.move_menu02-leave-active {
  animation: move_menu02 .5s reverse;
}
@keyframes move_menu02-zu {
  0% { left: 650px; opacity:0; }
  100% { left: 160px; opacity:1; }
}
move move_menu03
.menu_open.inactive .menu_03 {
  animation: move_menu03-zu .5s;
  animation-delay: 0.5s;
  animation-direction: reverse;
}
.move_menu03-leave-active {
  animation: move_menu03 .5s reverse;
}
@keyframes move_menu03-zu {
  0% { left: 650px; opacity:0; }
  100% { left: 320px; opacity:1; }
}
move move_menu04
.menu_open.inactive .menu_04 {
  animation: move_menu04-zu .5s;
  animation-delay: 0.75s;
  animation-direction: reverse;
}
.move_menu04-leave-active {
  animation: move_menu04 .5s reverse;
}
@keyframes move_menu04-zu {
  0% { left: 650px; opacity:0;}
  100% { left: 480px; opacity:1; }
} */

#cookienachricht {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    padding: 0px 10px 10px 10px;
    background: rgba(235,235,235,0.5);
    text-align: center;
    font-family: "Open sans", sans-serif;
    font-size: 12px;
}
/*button {
    background-color: #eb3d28;
    border: 0;
    padding: 5px;
    color: white;
}
*/
#cookienachricht img {
    width: 150px;
    margin-top: 0;
    /*float: right;*/
    margin-bottom: -15px;
}

.deaktivieren {
    text-color: blue;
    text-decoration:  underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Topmenu.vue